import React, { useRef, useEffect } from 'react';

import PageTransition from "./page-transition";
import Container from "../components/Cursor/container";

const HomeWorkItem = ({
  id,
  header,
  titleLine1,
  titleLine2,
  image,
  tagLine,
  color,
  setCurrentItem,
  scrollTopOffset,
  currentItem,
  isFirst,
  isLast,
  ...rest
}) => {
  const itemRef = useRef(null);

  useEffect(() => {
    const topOffset = itemRef.current.offsetTop + scrollTopOffset.top;
    const bottomOffset = topOffset + itemRef.current.offsetHeight;

    if (
      topOffset - (window.innerHeight / 2) < scrollTopOffset.scroll &&
      bottomOffset > scrollTopOffset.scroll
    ) {
      setCurrentItem(id)
    }
  }, [scrollTopOffset.scroll]);

  let bgcolor: any = {backgroundColor: currentItem.color};

  if (isFirst) {
    bgcolor = {
      ...bgcolor,
      backgroundImage: `linear-gradient(to bottom, #F5F5F5, ${currentItem.color})`
    };
  }

  if (isLast) {
    bgcolor = {
      ...bgcolor,
      backgroundImage: `linear-gradient(to bottom, ${currentItem.color}, #F5F5F5)`
    };
  }

  const toPage = `/works/cab?id=${id}`;

  return (
    <Container
      innerRef={i => {itemRef.current = i}}
      className="hp-work"
      cursorColor={currentItem.cursor}
      style={{...bgcolor}}>
      <div className="hp-work-item">
        <div className="hp-work-item-grid">
          <div className="hp-work-item-grid-right">
            <PageTransition to={toPage} className="hp-work-item-grid-image-anchor">
              <div className="hp-work-item-grid-image" style={{ backgroundImage: `url(${image})` }} />
            </PageTransition>
          </div>
          <div className="hp-work-item-grid-left">
            <div className="hp-work-item-grid-header">
              <h5>{header}</h5>
            </div>
            <div className="hp-work-item-grid-text">
              <h3>{titleLine1} {titleLine2}</h3>
            </div>
            <div className="hp-work-item-grid-header-tag">
              <h6>{tagLine}</h6>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default HomeWorkItem;
